import { useEffect, useState } from 'react';

const useTableOfContents = (containerSelector) => {
    const [tocItems, setTocItems] = useState([]);

    useEffect(() => {
        let observer;
        let container = document.querySelector(containerSelector);

        const generateTOC = () => {
            if (!container) return;

            const headings = container.querySelectorAll('h1, h2, h3');
            const items = Array.from(headings).map((heading) => {
                if (!heading.id) {
                    // Generate an ID if not already set
                    heading.id = heading.textContent
                        .toLowerCase()
                        .replace(/[^a-z0-9]+/g, '-')
                        .replace(/(^-|-$)+/g, '');
                }

                return {
                    id: heading.id,
                    text: heading.textContent,
                    level: parseInt(heading.tagName[1]),
                };
            });

            setTocItems(items);
        };

        // Try to find the container initially
        const init = () => {
            container = document.querySelector(containerSelector);
            if (!container) return;

            generateTOC();

            observer = new MutationObserver(() => {
                generateTOC();
            });

            observer.observe(container, {
                childList: true,
                subtree: true,
            });
        };

        init();

        return () => {
            if (observer) {
                observer.disconnect();
            }
        };
    }, [containerSelector]);

    return tocItems;
};

export default useTableOfContents;

